import React from "react";
import { MessageCircle } from "lucide-react";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: Adds smooth scrolling
    });
  };

  return (
    <footer className="bg-[#00436b] text-white py-12" aria-label="Footer Section">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Elam Travels Trichy</h3>
            <p className="text-white">
              We offer the best-customized tour & holiday packages to explore
              your destinations. Safe Rides, Guaranteed. Book a ride for your
              wonderful travel.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a
                  onClick={scrollToTop}
                  className="text-white hover:text-gray-300 transition"
                  aria-label="Go to Home Page"
                >
                  Home
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>Car Rental</li>
              <li>Tempo Traveller</li>
              <li>Temple Tourism</li>
              <li>Airport Transfer</li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Connect With Us</h3>
            <p className="text-white">
              Email: info@elamtravelstrichy.com
              <br />
              Phone: +91 99409 06161
            </p>
          </div>
        </div>

        <div className="border-t border-gray-400 mt-8 pt-8 text-center text-white">
          <p>
            &copy; {new Date().getFullYear()} Elam Travels Trichy. All rights
            reserved.
          </p>
        </div>
      </div>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/+919940906161"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition transform hover:scale-105 flex items-center space-x-2"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle size={24} />
        <span className="hidden md:inline-block text-lg font-medium">
          Chat Now
        </span>
      </a>
    </footer>
  );
}
